import { COLORS } from '@/constants';
import { Button } from '@mui/material';
import styled from 'styled-components';

export const ShareBtnBox = styled.div`
  display: flex;
  gap: 6px;
  height: 32px;
`;

export const ButtonCopyStyled = styled(Button)<{ $isCopied?: boolean }>`
  &.MuiButtonBase-root.MuiButton-root {
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    padding: 0;
    background: ${(props) => (props.$isCopied ? COLORS.white : COLORS.yellow)};
    color: ${(props) => (props.$isCopied ? COLORS.yellow : COLORS.white)};
    border-color: ${COLORS.yellow};
    transparent: ${(props) => (props.$isCopied ? 1 : 9.8)};
    border-width: 2px;

    svg {
      width: 20px;
      height: 20px;
      color: ${(props) => (props.$isCopied ? COLORS.yellow : COLORS.white)};
    }
  }
`;
